const footer = {
    init: () => {
        $(".site-footer__linklist-item a[href='https://thevitacococompany.com/']").prop('target', '_blank');

        //The Gorgias button customization, so that when customers click outside of the chat box it will automatically close the chat box.
        $('body').on("click", function (e) {
            if ($(e.target).parents('#gorgias-chat-container').length == 0) {
                if ($('#chat-window.visible')) {
                    GorgiasChat.close();
                }
            }
        });
    }
};
export default footer;